<div *ngIf="error == null" class="ui container" style="padding-top: 30px">
  <div
    class="ui segment"
    style="padding: 0px; border: 0px; box-shadow: none"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div
      class="ui grid"
      *ngIf="paymentTransaction != null"
      style="
        margin-left: 0px;
        margin-right: 0px;
        border: 1px solid #dfdfdf;
        border-radius: 3px;
        background-color: #f0f1f8;
        padding-left: 15px;
        padding-right: 10px;
        padding-top: 25px;
      "
    >
      <div class="sixteen wide column">
        <div class="ui two column grid">
          <div class="column middle aligned">
            <a
              *ngIf="paymentTransaction.status == 'CONFIRMED'"
              style="
                width: min-content;
                border-radius: 10px;
                padding-left: 15px;
                padding-right: 15px;
              "
              class="ui mini label"
              [ngClass]="{
                green: paymentTransaction.status === 'CONFIRMED'
              }"
            >
              {{ paymentTransaction.status }}
            </a>
            <h2 class="ui header primary">Transaction Details</h2>
          </div>
          <div class="column right aligned">
            <button
              *ngIf="
                paymentTransaction.status == 'AWAITING_PAYMENT' ||
                paymentTransaction.status == 'PROOF_OF_PAYMENT_UPLOADED'
              "
              class="ui primary button"
              (click)="uploadProofOfPayment()"
              style="margin-left: 10px; background-color: #47c672"
              [disabled]="uploaded"
            >
              Upload Proof of Payment
            </button>
            <button
              class="ui primary basic button"
              *ngIf="isApplicationFeePayment(paymentTransaction)"
              (click)="goToPaymentSummary(paymentTransaction)"
            >
              Back to Tamsy
            </button>
            <button
              class="ui primary basic button"
              *ngIf="paymentTransaction.initiationType === 'E_WALLET_FUNDING'"
              (click)="goToWallet()"
            >
              Back to eWallet Page
            </button>
          </div>
        </div>
      </div>
      <div class="four wide column">
        <div class="header-text">COMPANY NAME</div>
        <div class="header-bottom-text">
          {{ paymentTransaction.companyName || "-" }}
        </div>
      </div>
      <div class="four wide column">
        <div class="header-text">REVENUE SERVICE</div>
        <div class="header-bottom-text">
          {{ paymentTransaction.revenueServiceName }}
        </div>
      </div>
      <div class="four wide column">
        <div class="header-text">AMOUNT</div>
        <div class="header-bottom-text">
          {{
            paymentTransaction.totalAmount
              | currency: paymentTransaction.currencyCode
          }}
        </div>
      </div>
      <div class="four wide column">
        <div class="header-text">INVOICE NUMBER</div>
        <div class="header-bottom-text">
          {{ paymentTransaction.invoiceNumber || "-" }}
        </div>
      </div>

      <div class="ui divider container"></div>

      <div class="four wide column">
        <div class="header-text">REVENUE SERVICE</div>
        <div class="header-bottom-text">
          {{ paymentTransaction.revenueServiceName }}
        </div>
      </div>
      <div class="four wide column">
        <div class="header-text">INVOICE TYPE</div>
        <div class="header-bottom-text">{{ invoiceDetails?.invoiceType }}</div>
      </div>
      <!-- <div class="three wide column">
			<div class="header-text">LICENSE TYPE</div>
			<div class="header-bottom-text">{{paymentTransaction.categoryName}}</div>
		</div> -->
      <div class="four wide column">
        <div class="header-text">VALIDITY PERIOD</div>
        <div class="header-bottom-text">
          {{ invoiceDetails?.validityPeriod || "-" }} days
        </div>
      </div>
      <div class="four wide column">
        <div class="header-text">ISSUE DATE</div>
        <div class="header-bottom-text">
          {{ invoiceDetails?.serviceStartDate | date }} -
          {{ invoiceDetails?.serviceEndDate | date }}
        </div>
      </div>
    </div>

    <div class="ui two column grid" style="padding-top: 30px">
      <div class="column middle aligned">
        <h2 class="ui header primary">Proofs of Payment</h2>
      </div>
      <div class="column right aligned"></div>
    </div>

    <div class="ui segment table header" tamsyMargin>
      <div fxLayout="row" fxLayoutAlign="start">
        <div fxFlex="5%">
          <div class="ui description" tamsyMargin="0">S/N</div>
        </div>
        <div fxFlex="15%">
          <div class="ui description" tamsyMargin="0">NAME OF BANK</div>
        </div>
        <div fxFlex="15%">
          <div class="ui description" tamsyMargin="0">DESCRIPTION</div>
        </div>
        <div fxFlex="15%">
          <div class="ui description" tamsyMargin="0">BANK BRANCH</div>
        </div>
        <div fxFlex="15%">
          <div class="ui description" tamsyMargin="0">BANK COUNTRY</div>
        </div>
        <div fxFlex="15%">
          <div class="ui description" tamsyMargin="0">TELLER NUMBER</div>
        </div>
        <div fxFlex="15%">
          <div class="ui description" tamsyMargin="0">PAYER'S EMAIL</div>
        </div>
        <div fxFlex="5%"></div>
      </div>
    </div>

    <app-no-record-found
      *ngIf="proofOfPayments && proofOfPayments.length < 1"
    ></app-no-record-found>
    <app-no-record-found *ngIf="!proofOfPayments"></app-no-record-found>

    <div
      class="ui segment"
      tamsyMargin
      *ngFor="let item of proofOfPayments; index as i"
    >
      <div fxLayout="row" fxLayoutAlign="start">
        <div fxFlex="5%">
          <div class="ui item description" tamsyMargin="0">{{ i + 1 }}</div>
        </div>
        <div fxFlex="15%">
          <div class="ui item description" tamsyMargin="0">
            {{ item.nameOfBank }}
          </div>
        </div>
        <div fxFlex="15%">
          <div class="ui item description" tamsyMargin="0">
            {{ item.description }}
          </div>
        </div>
        <div fxFlex="15%">
          <div class="ui item description" tamsyMargin="0">
            {{ item.nameOfBankBranch }}
          </div>
        </div>
        <div fxFlex="15%">
          <div class="ui item description" tamsyMargin="0">
            {{ item.bankCountry }}
          </div>
        </div>
        <div fxFlex="15%">
          <div class="ui item description" tamsyMargin="0">
            {{ item.tellerNumber }}
          </div>
        </div>
        <div fxFlex="15%">
          <div class="ui item description" tamsyMargin="0">
            {{ item.payerEmail }}
          </div>
        </div>
        <div fxFlex="5%">
          <button
            class="ui circular tiny button"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            popupText="view uploaded document"
            (click)="viewDocument(item)"
          >
            <i class="eye icon"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="error != null"
  class="ui container"
  style="margin-top: 50px; padding-top: 50px; padding-bottom: 50px"
>
  <div fxLayoutAlign="center center">
    <img src="../../../../assets/images/404.png" style="height: 300px" />
  </div>
  <div
    style="padding-top: 50px; font-size: 40px; font-weight: bold"
    fxLayoutAlign="center center"
    class="header"
  >
    ERROR
  </div>
  <div fxLayoutAlign="center center" style="padding-top: 50px; font-size: 30px">
    Invalid transaction reference id supplied
  </div>
  <div fxLayoutAlign="center center" class="normal-text"></div>
</div>
